import axios from 'axios';
import querystring from 'query-string';
import urls from './urls';

const getListTransporter = async (companyName = '') => {
  try {
    const filters = {
      page: 0,
      size: 20,
      sort: 'companyName,asc',
    };
    if (companyName) {
      filters.companyName = companyName;
    }
    const res = await axios.get(`${urls.listTransporter}?${querystring.stringify(filters)}`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getListShipper = async (companyName = '') => {
  try {
    const filters = {
      page: 0,
      size: 20,
      sort: 'companyName,asc',
    };
    if (companyName) {
      filters.companyName = companyName;
    }
    const res = await axios.get(`${urls.listShipper}?${querystring.stringify(filters)}`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getListTransporterAndCustomer = async () => {
  try {
    const resListTransporter = await getListTransporter();
    const resListShipper = await getListShipper();
    return Promise.all([resListTransporter, resListShipper]);
  } catch (error) {
    return Promise.reject(error);
  }
};

const getListCalender = async ({
  date,
  shipperId,
  transporterId,
}, source) => {
  try {
    const filters = {
      date, shipperId, transporterId,
    };
    if (shipperId) {
      filters.shipperId = shipperId;
    } else {
      delete filters.shipperId;
    }
    if (transporterId) {
      filters.transporterId = transporterId;
    } else {
      delete filters.transporterId;
    }
    const res = await axios.get(`${urls.listCalender}?${querystring.stringify(filters)}`, {
      cancelToken: source.token,
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const getListExpandCalender = async (shipmentId, source) => {
  try {
    const res = await axios.get(`${urls.listCalender}/${shipmentId}`, {
      cancelToken: source.token,
    });
    return res?.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export {
  getListTransporter,
  getListShipper,
  getListTransporterAndCustomer,
  getListCalender,
  getListExpandCalender,
};
